import { vservice } from '@niknevis/vue-modules'
import dayjs from 'dayjs'

@vservice()
export class DateHelper {
  public $d!: dayjs.Dayjs

  private dateFormat = 'HH:mm YYYY/MM/DD'

  private timestampFormat = 'YYYY-MM-DD HH:mm:ss'

  setFormat(dateFormat: string) {
    this.dateFormat = dateFormat
    return this
  }

  setTimestampFormat(format: string) {
    this.timestampFormat = format
  }

  isJalali(string: string) {
    return dayjs(string).isJalali()
  }

  fromISO(isoString: string) {
    this.$d = dayjs(isoString)
    return this
  }

  fromJalali(date: string, format = this.dateFormat) {
    this.$d = dayjs(date, {
      format: format,
      // @ts-ignore
      jalali: true
    })
    return this
  }

  fromTimestamp(date: string) {
    this.$d = dayjs(date, this.timestampFormat)
    return this
  }

  toOffsetDate(isoString = this.$d) {
    return dayjs(isoString).fromNow()
  }

  toDate(isoString = this.$d) {
    return dayjs(isoString).format()
  }

  toJalali(isoString = this.$d) {
    return dayjs(isoString).format(this.dateFormat)
  }

  toTimestamp(isoString = this.$d) {
    return dayjs(isoString)
      .calendar('gregory')
      .locale('en')
      .format(this.timestampFormat)
  }

  toGregory(isoString = this.$d) {
    return dayjs(isoString)
      .calendar('gregory')
      .locale('en')
  }

  day() {
    return this.$d
  }
}
